import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { from } from 'rxjs';

import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    RESET,
    SET as patientSET
} from 'one-state-subject/src/types';

import {
    addAction,
    disableAddAction,
    setAction,
    reinitAction,
    setStatusAction
} from 'one-state-notes-history';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
    addAction as errorAddAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';

export const enum Types {
    NOTES_HISTORY__ADD = "notes-history--add",
    STORE_DISPOSITION_CODE = "store-disposition-code"
};

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of notes history epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const enum Types {
    GETSESSION_FETCH = "one-state-getsession/fetch"
}
export const fetchNotesHistoryEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { log, server, agentId, teamName, interactionApi, settings: {
            servers,
            epicendpoints: {
                getnotes,
                apitoken
            },
            compatible: { consolidated_api_invocation, contact_center_type },
            uisettings: { agent_notes: { agentIdtie } }
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED,Types.GETSESSION_FETCH),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                
                if (contact_center_type === 'five9') {
                    let five9AgentId = sessionStorage.getItem("five9_userid");
                    interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${five9AgentId}`, method: 'GET', payload: null })
                        .then(function (result: any) {
                            // resolve handler
                            const { response } = result
                            const data = JSON.parse(response.replace('/', ''))
                            sessionStorage.setItem("agentName", data.fullName);
                        }, function (error: any) {
                            // reject handler
                            log.debug('Call variables error ', error);
                        }
                    );
                }

                const getRequest = (datares: any) => {
                let subjectid = datares?.id ? datares?.id : state$.value?.wxccInteraction?.wxccInteractionId;
        //         let wxccInteraction= state$.value?.wxccInteraction?.wxccInteractionId
        //      switch (agentIdtie) {
        //     case "patientId":
        //         subjectid = datares?.id;
        //         break;
        //     case "wxccInteractionId":
        //         subjectid = wxccInteraction;
        //         break;
        //     default:
        //         subjectid = undefined;
        //         break;
        // }
                    if (subjectid) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let response;
                        
                        response = server.get({
                            path: `${getnotes}?patient_id=${subjectid}`,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                let errorbuild: ErrorObject = {
                                    source: "NotesHistory",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors ?? [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        mergeMap(response => {
                            const actions: any = [
                                setAction(response)];
                                let disp: Disposition = { 
                                    value: response?.error ? "2024" : "2023", 
                                    meta02: response?.error ? response.error.status: '200', 
                                    meta04: response?.error ? response.error?.display_text : 'client'
                                };
                                
                                if (contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }

                                disp.meta03 = dataresponse.id;
                                if (response.error) {
                                    actions.push(errorAddAction(response.error));
                                    disp.meta05 = 'client';
                                }
                                actions.push(pushToDisposition(disp));
                            
                            return actions;
                        })
                    )
            })
        )
    }
);

export const addNotesHistoryEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, agentId, agentLoginName, teamName, settings: {
            epicendpoints: {
                addnotes,
                apitoken
            },
            uisettings: {
                agent_notes: { eteToSave,agent_notes_enable_without_id }
            },
            compatible: { contact_center_type },
        } } = context;
        return action$.pipe(
            ofType(Types.NOTES_HISTORY__ADD),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                let agentIdValue; // agent name
                if (contact_center_type === 'five9' || contact_center_type === 'genesys' || contact_center_type === 'inContact') {
                    agentIdValue = sessionStorage.getItem("agentName");
                } else if (contact_center_type === 'finesse') {
                    agentIdValue = agentLoginName;
                } else if (contact_center_type === 'twilio') {
                    agentIdValue = sessionStorage.getItem("twilio_userid");
                } else if (contact_center_type === 'wxcc') {
                    agentIdValue = sessionStorage.getItem("wxcc_userid");
                } else if (contact_center_type === 'ringcentral') {
                    agentIdValue = sessionStorage.getItem("ringcentral_agentName");
                } else {
                    agentIdValue = agentId;
                }

                const getRequest = (datares: any, agentIdValue: any) => {
                    if (datares?.patientId) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let response;
                     let data = {};
                        if (eteToSave.epic) {
                            data = {
                                patient_id: datares.patientId,
                                agent_id: agentIdValue,
                                notes: datares.note,
                                isEpic: true,
                                epic: {
                                    epic_userid: state$.value.epicuserid?.agentuserid,
                                    patient_MRN: state$.value.subjectstore?.selected?.prescriptionMRNData,
                                    first_name: state$.value.subjectstore?.selected?.firstname,
                                    last_name: state$.value.subjectstore?.selected?.lastname,
                                    middle_name_initial: state$.value?.subjectstore?.selected?.middlename,
                                    dob: state$.value.subjectstore?.selected?.dob,
                                    gender: state$.value.subjectstore?.selected?.gender
                                }
                            };
                        } else {
                            data = {
                                patient_id: datares.patientId,
                                agent_id: agentIdValue,
                                notes: datares.note,
                            };
                        }
                        response = server.post({
                            path: addnotes,
                            headers: headers,
                            data: data
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                let errorbuild: ErrorObject = {
                                    source: "NotesHistory",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors ?? [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }

            //     if(!agent_notes_enable_without_id){
            //     if (!agentIdValue) {
            //         console.log("Blocking API call: agentIdValue is missing and agent_notes_enable_without_id is false");
            //         const actions: any = [];
            //         // dispatch action to disable add notes
            //         actions.push(disableAddAction(true));
            //         return from(actions);
            //     }
            // }
                return getRequest(dataresponse, agentIdValue).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        mergeMap((response: any) => {
                            const actions: any = [];
                            actions.push(addAction(response));
                            if (response.error) {
                                actions.push(errorAddAction(response.error));
                                let disp: Disposition = { value: '2026' }
                                if (contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = response.error.status;
                                disp.meta03 = dataresponse.patientId;
                                disp.meta04 = response.error?.display_text;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                                actions.push(setStatusAction(400));
                            } else {
                                let disp: Disposition = { value: '2025' }
                                if (contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("five9_userid");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = '200';
                                disp.meta03 = dataresponse?.id;
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                                actions.push(setStatusAction(200));
                            }
                            
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Fuction will clear data of notes history epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearNotesEpic = (context: any) => (
    (action$: any) => {
        return action$.pipe(
            ofType(RESET),
            map(action => reinitAction())
        )
    }
);
